import './App.css';
import Layout from './src/layout/layout';
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from './src/pages/errorPage';
import SuspendedPage from './src/pages/suspendedPage';
import { isSuspended } from './src/tools/parameters';

function App() {

	// Gate sits above Layout on purpose: no router, no user fetch,
	// no cart — direct links like /cart land here too.
	if (isSuspended) return <div className="App"><SuspendedPage /></div>

	return <div className="App">
		<ErrorBoundary FallbackComponent={ErrorPage}>
			<Layout />
		</ErrorBoundary>
	</div>
}



export default App;
